import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantTaskTemplate } from '../mutations/deleteParticipantTaskTemplate.mutation';
import type {
  DeleteParticipantTaskTemplateMutation,
  DeleteParticipantTaskTemplateMutationVariables,
} from '../types';

export const useDeleteParticipantTaskTemplateMutation = (
  options?: MutationOptions<
    DeleteParticipantTaskTemplateMutation,
    DeleteParticipantTaskTemplateMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantTaskTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participantTaskTemplates'),
      });
    },
  });
};
